<template>
  <div class="row">
    <div class="col-xl-12"> 
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/AlertReport/BeforeDue'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }} <br>
              <i class='text-danger' style="font-size: 0.8em;">* รายงานแจ้งเตือนคงค้างก่อนครบกำหนดการคืนโรงงาน</i>
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form --> 
          
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
               

              <!---
                v-if="this.$root.canShow(['BR_REPORT']) && ViewPermissionCode != 'AGENT_REPORT'"
                -->
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['super_admin'])">
                <div class="form-group">
                  <label>ต้นทาง(โรงงาน/คลังสินค้า):</label>
                  <treeselect
                    v-model="OdCurrentLocationPlant"
                    :multiple="true"
                    :options="OdCurrentLocationPlantOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              
                
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่รับเข้าจากโรงงาน(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="StartDate"
                      name="StartDate"
                      ref="StartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่รับเข้าจากโรงงาน(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="EndDate"
                      name="EndDate"
                      ref="EndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Barcode:</label>
                  <input
                    v-model="OdBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <treeselect
                    v-model="OdProductTypeId"
                    :multiple="true"
                    :options="OdProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <treeselect
                    v-model="OdAssetCode"
                    :multiple="true"
                    :options="OdAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <treeselect
                    v-model="OdBrandId"
                    :multiple="true"
                    :options="OdBrandIdOptions" 
                     v-on:select="OdBrandIdClearAfterselect"
                     v-on:deselect="OdBrandIdDeSelect"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อแบรนด์สินค้า:</label>
                  <treeselect 
                    id="OdFinishProductId"
                    v-model="OdFinishProductId"
                    :multiple="true"
                    :load-options="LoadOdFinishProductIdOptions"
                    v-on:open="reLoadOdFinishProductIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="OdFinishProductId"   
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">เดือน(คงค้าง):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(ดด/ปปปป)"
                      id="OdOverMonth"
                      name="OdOverMonth"
                      ref="OdOverMonth"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ช่วงเวลา:</label>
                  <treeselect 
                    id="OdPeriodRange" 
                    v-model="OdPeriodRange" 
                    :multiple="false" 
                    :options="OdPeriodRangeOptions"
                    :clear-on-select="true" 
                    placeholder="กรุณาเลือก" 
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                  <treeselect
                    v-model="OdScanByUser"
                    :multiple="true"
                    :options="OdScanByUserOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"  v-if="this.$root.canShow(['super_admin'])" >

                <div class="form-group">
                  <label>มุมมองผู้ใช้งาน:</label>
                  <treeselect id="ViewPermissionCode" 
                    v-model="ViewPermissionCode" 
                    :multiple="false" 
                    :options="OdViewPermissionOptions"
                    placeholder="กรุณาเลือก" 
                    @input="ChangeOptions('View')" 
                    :clearable="false"
                    :clear-on-select="false"
                  />
                </div>
              </div>

              <!--Begin : Collap ค้นหาผู้ถือครอง-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาผู้ถือครอง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la	la-plus-square"></i> ค้นหาผู้ถือครอง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                    <div class="row">
                      

                      <div
                        v-if="this.$root.canShow(['BR_REPORT','AGENT_REPORT'])"
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ผู้ถือครอง(ตัวแทนจำหน่าย):</label>
                          <treeselect
                            id="OdCurrentLocationAgent"
                            v-model="OdCurrentLocationAgent"
                            :multiple="true"
                            :options="OdCurrentLocationAgentOptions"
                            :clear-on-select="true"
                            v-on:select="AgentClearAfterselect"
                             v-on:deselect="AgentClearAfterselect"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>


                      <div
                        v-if="this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT'])"
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ผู้ถือครอง(ตัวแทนจำหน่ายย่อย):</label>
                          <treeselect
                            id="OdCurrentLocationSubAgent"
                            v-model="OdCurrentLocationSubAgent"
                            :multiple="true"
                            :load-options="LoadOdCurrentLocationSubAgentOptions"
                            v-on:open="reLoadOdCurrentLocationSubAgentOptions"
                            :async="true"
                            v-on:select="SubAgentClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                            ref="OdCurrentLocationSubAgent"  

                            
                          />
                        </div>
                      </div>

                      

                      <div
                        v-if="this.$root.canShow(['AGENT_REPORT'])"
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ผู้ถือครอง(ร้านค้าตัวแทน):</label>
                          <treeselect 
                            id="OdCurrentLocationShop"
                            v-model="OdCurrentLocationShop"
                            :multiple="true"
                            :load-options="LoadOdCurrentLocationShopOptions"
                            v-on:open="reLoadOdCurrentLocationShopOptions"
                            :async="true"
                            v-on:select="ShopClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                            ref="OdCurrentLocationShop"  
                          />
                        </div>
                      </div>

                      

                      <div
                        v-if="this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT'])"
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ผู้ถือครอง(ร้านค้าตัวแทนจำหน่ายย่อย):</label>
                          <treeselect
                            id="OdCurrentLocationSubShop"
                            v-model="OdCurrentLocationSubShop"
                            :multiple="true"
                            :load-options="LoadOdCurrentLocationSubShopOptions"
                            v-on:open="reLoadOdCurrentLocationSubShopOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                            ref="OdCurrentLocationSubShop"
                          />
                        </div>
                      </div>

                      <div
                        v-if="this.$root.canShow(['BR_REPORT']) && ViewPermissionCode != 'AGENT_REPORT' && false"
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ผู้ถือครอง(ซัพพลายเออร์):</label>
                          <treeselect
                            v-model="OdCurrentLocationVendor"
                            :multiple="true"
                            :load-options="LoadOdCurrentLocationVendorOptions"
                            v-on:open="reLoadOdCurrentLocationVendorOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="true"
                            ref="OdCurrentLocationVendor"
                          />
                        </div>
                      </div>

                      <div 
                        v-if="this.$root.canShow(['BR_REPORT']) && ViewPermissionCode != 'AGENT_REPORT' && false" 
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>พนักงาน :</label>
                          <treeselect 
                            v-model="OdEmpId"
                            :multiple="true"
                            :load-options="LoadOdEmpIdOptions"
                            v-on:open="reLoadOdEmpIdOptions"
                            :async="true"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            v-on:select="ClearAfterselect"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="true"
                            ref="OdEmpId"
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาผู้ถือครอง-->
            </div> 
             
            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT','BR_REPORT',])"
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportOverdueAll"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
import Collapsible from "../../Shared/Collapsible";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      StartDate: null,
      EndDate: null,
      OdOverMonth: null,
      OdPeriodRange: null,
      OdBarcode: null,
      OdProductTypeId: [],
      OdBrandId: [],
      OdFinishProductId:[],
      OdAssetCode: [],
      OdScanByUser : [],
      ViewPermissionCode: null,
      OdViewPermissionOptions: [], 
      
      OdCurrentLocationPlant: [],
      OdCurrentLocationAgent: [],
      OdCurrentLocationSubAgent: [],
      OdCurrentLocationShop: [],
      OdCurrentLocationSubShop: [],
      OdCurrentLocationVendor: [],
      OdEmpId: [],
      OdProductTypeIdOptions: [],
      OdBrandIdOptions: [],
      OdFinishProductIdOptions :[],
      OdAssetCodeOptions: [],
      OdScanByUserOptions : [],
      OdCurrentLocationPlantOptions: [],
      OdCurrentLocationAgentOptions: [],
      OdCurrentLocationSubAgentOptions: [],
      OdCurrentLocationShopOptions: [],
      OdCurrentLocationSubShopOptions: [],
      OdCurrentLocationVendorOptions: [],
      OdEmpIdOptions: [],
      OdPeriodRangeOptions: [],
 
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.StartDate = null;
      self.EndDate = null;
      self.OdOverMonth = null;
      self.OdPeriodRange = null;
      self.OdBarcode = null;
      self.OdProductTypeId = [];
      self.OdBrandId = [];
      self.OdFinishProductId = [];
      self.OdAssetCode = [];
      self.OdScanByUser = [];
      self.OdCurrentLocationPlant = [];
      self.OdCurrentLocationAgent = [];
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];
      self.OdCurrentLocationVendor = [];
      self.OdEmpId = []; 

      $("#StartDate").val("").trigger("change");
      $("#EndDate").val("").trigger("change");
      $("#OdOverMonth").val("").trigger("change");
      $("#OdPeriodRange").val("").trigger("change");
      $("#OdBarcode").val("").trigger("change");
      $("#OdProductTypeId").val("").trigger("change");
      $("#OdBrandId").val("").trigger("change");
      $("#OdFinishProductId").val("").trigger("change");
      $("#OdAssetCode").val("").trigger("change");
      $("#OdScanByUser").val("").trigger("change");
      $("#OdCurrentLocationPlant").val("").trigger("change");
      $("#OdCurrentLocationAgent").val("").trigger("change");
      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("#OdCurrentLocationVendor").val("").trigger("change");
      $("#OdEmpId").val("").trigger("change");
 
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportOverdueAll: function(e) {
      e.preventDefault();
      let self = this; 

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      var curentShop = [];
      if (
        self.OdCurrentLocationSubAgent.length != 0 ||
        self.OdCurrentLocationShop.length
      ) {
        curentShop = self.OdCurrentLocationSubAgent.concat(
          self.OdCurrentLocationShop
        );
      }

      axios({
        method: "post",
        url: "/Api/ReportOverdue/ExportBeforedueAll",
        responseType: "arraybuffer",
        data: {
          //StartDate: self.StartDate,
          //EndDate: self.EndDate,
          StartDate:
              self.StartDate != null
                ? self.StartDate.format("DD/MM/YYYY")
                : self.StartDate,
            EndDate:
              self.EndDate != null
                ? self.EndDate.format("DD/MM/YYYY")
                : self.EndDate,

          Barcode: self.OdBarcode,
          ProductTypeId: self.OdProductTypeId,
          ProductCode: self.OdAssetCode,
          BrandId: self.OdBrandId,
          FinishProductIds : self.OdFinishProductId,
          ViewPermissionCode: self.ViewPermissionCode,
          OdOverMonth: self.OdOverMonth != null
                ? self.OdOverMonth.format("MM/YYYY")
                : self.OdOverMonth,
          OdPeriodRange: self.OdPeriodRange,
          OdScanByUser: self.OdScanByUser,
          CurrentLocationPlant: self.OdCurrentLocationPlant,
          CurrentLocationAgent: self.OdCurrentLocationAgent,
          CurrentLocationSubAgent: self.OdCurrentLocationSubAgent,
          CurrentLocationShop: self.OdCurrentLocationShop,
          CurrentLocationSubShop: self.OdCurrentLocationSubShop,
          CurrentLocationVendor: self.OdCurrentLocationVendor,
          CurrentLocationEmp : self.OdEmpId,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
     
    LoadOdProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOdBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    reLoadOdFinishProductIdOptions: function(){
      this.$refs.OdFinishProductId.trigger.searchQuery = null;
    },
    LoadOdFinishProductIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdFinishProductIdOptions = [];
  
      if (action === ASYNC_SEARCH) {
        axios 
          .post("/Api/product/Select2ProductReport", {
            page: 1,
              all: true, 
              search: searchQuery ,
              productBrandIds : self.OdBrandId,
              productGroupIds : [14],
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdFinishProductIdOptions = [];
              data.forEach((element) => {
                self.OdFinishProductIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdFinishProductIdOptions);
          });
      }
    }, 
    LoadOdAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
            excludeProductGroupId : 14
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOdScanByUserOptions() {
      var self = this;
      axios
        .get("/Api/ReportOverdue/Select2OverdueAlertUserOption", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdScanByUserOptions = [];
            data.forEach((element) => {
              self.OdScanByUserOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOdCurrentLocationPlantOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdCurrentLocationPlantOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOdCurrentLocationAgentOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: [],
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdCurrentLocationAgentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    reLoadOdCurrentLocationSubAgentOptions: function(){
      this.$refs.OdCurrentLocationSubAgent.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubAgentOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdCurrentLocationSubAgentOptions = [];
  
      if (action === ASYNC_SEARCH) {
        axios
        .post("/Api/Report/Select2SubShopAgent", {
            page: 1,
            onlySubAgent: true,
            all: true,
            search: searchQuery ,
            agentCodes : self.OdCurrentLocationAgent,
            shopCodes : self.OdCurrentLocationShop
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdCurrentLocationSubAgentOptions = [];
              data.forEach((element) => {
                self.OdCurrentLocationSubAgentOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdCurrentLocationSubAgentOptions);
          });
      }
    }, 
    reLoadOdCurrentLocationShopOptions: function(){
      this.$refs.OdCurrentLocationShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationShopOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdCurrentLocationShopOptions = [];
  
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Shop/Select2ShopByAgentAlerReport", {
            page: 1,
              all: true,
              agentCodes : self.OdCurrentLocationAgent,
              customerCode : self.OdCurrentLocationSubAgent,
              search: searchQuery 
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdCurrentLocationShopOptions = [];
              data.forEach((element) => {
                self.OdCurrentLocationShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdCurrentLocationShopOptions);
          });
      }
    },
    reLoadOdCurrentLocationSubShopOptions: function(){
      this.$refs.OdCurrentLocationSubShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubShopOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdCurrentLocationSubShopOptions = [];
      var allShops = [];
       
      if( self.OdCurrentLocationSubAgent!=null &&  self.OdCurrentLocationSubAgent.length > 0){
        for (var i = 0, len = self.OdCurrentLocationSubAgent.length; i < len; ++i) {
          allShops.push(self.OdCurrentLocationSubAgent[i]);
        }
      }
      if( self.OdCurrentLocationShop!=null &&  self.OdCurrentLocationShop.length > 0){
        for (var i = 0, len = self.OdCurrentLocationShop.length; i < len; ++i) {
          allShops.push( self.OdCurrentLocationShop[i]);
        }
      }

      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Shop/SubShopOptionAlertReport", {
        
              page: 1,
              all: true,
              search: searchQuery,
              agentCodes : self.OdCurrentLocationAgent,
              shopCodes  : allShops,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdCurrentLocationSubShopOptions = [];
              data.forEach((element) => {
                self.OdCurrentLocationSubShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdCurrentLocationSubShopOptions);
          });
      }
    },
    reLoadOdCurrentLocationVendorOptions: function(){
      this.$refs.OdCurrentLocationVendor.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationVendorOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdCurrentLocationVendorOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdCurrentLocationVendorOptions = [];
              data.forEach((element) => {
                self.OdCurrentLocationVendorOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdCurrentLocationVendorOptions);
          })
          .catch(function(error) {});
      }
    },
    reLoadOdEmpIdOptions: function(){
      this.$refs.OdEmpId.trigger.searchQuery = null;
    },
    LoadOdEmpIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.OdEmpIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Employee/Select2Employee", {
            params: { page: 1, all: true, search: searchQuery },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.OdEmpIdOptions = [];
              data.forEach((element) => {
                self.OdEmpIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.OdEmpIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadOdPeriodOptions() {
      var self = this;
      axios
        .get("/Api/ReportOverdue/Select2PeriodOption", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdPeriodRangeOptions = [];
            data.forEach((element) => {
              self.OdPeriodRangeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    async LoadOdViewReturnProductOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewReturnProduct", {params: {search: '1'}})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OdViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });
              if (element.data == "active") {
                self.ViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    ChangeOptions(type) {
      var self = this;
      if (type == "View") {
        self.formReset();
      }
    }, 
    OdBrandIdDeSelect: function(){  
      let self = this;
      self.OdFinishProductId = []; 
 
      $("#OdFinishProductId").val("").trigger("change"); 
      $(`[class="vue-treeselect__input"]`).val("");

    },
    OdBrandIdClearAfterselect: function(){  
      let self = this;
      self.OdFinishProductId = []; 
 
      $("#OdFinishProductId").val("").trigger("change"); 
      $(`[class="vue-treeselect__input"]`).val("");

    },
    AgentClearAfterselect: function(){  
      let self = this;
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];  
 
      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    SubAgentClearAfterselect: function(){  
      let self = this; 
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];  
  
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    ShopClearAfterselect: function(){  
      let self = this;  
      self.OdCurrentLocationSubShop = [];   
      $("#OdCurrentLocationSubShop").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    
    ClearAfterselect: function(){ 
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    $(self.$refs.StartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.StartDate).datepicker(
      "update",
      !!self.StartDate ? self.StartDate.format("DD/MM/YYYY") : null
    ).on("changeDate", function(e) {
      self.StartDate = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.EndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.EndDate).datepicker(
      "update",
      !!self.EndDate ? self.EndDate.format("DD/MM/YYYY") : null
    ).on("changeDate", function(e) {
      self.EndDate = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.OdOverMonth).datepicker({
      format: "mm/yyyy",
      viewMode: "months",
      minViewMode: "months",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.OdOverMonth).datepicker(
      "update",
      !!self.OdOverMonth ? self.OdOverMonth.format("MM/YYYY") : null
    ).on("changeDate", function(e) {
      self.OdOverMonth = e.dates.length != 0 ? moment(e.date) : null;
    });

    await self.LoadOdViewReturnProductOptions();
    self.LoadOdProductTypeIdOptions();
    self.LoadOdBrandIdOptions();
    self.LoadOdAssetCodeOptions();
    self.LoadOdCurrentLocationPlantOptions();
    self.LoadOdCurrentLocationAgentOptions();
    //self.LoadOdCurrentLocationSubAgentOptions();
    self.LoadOdPeriodOptions();
    self.LoadOdScanByUserOptions();

      

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }
    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/ReportAlert/BeforeDue.vue